/** Deterministic thresholds (hours) — no ML/GPS. */
export const INTEL_PARTIAL_STALL_HOURS = 6;
export const INTEL_CARGO_INACTIVE_HOURS = 8;
export const INTEL_STOP_STUCK_HOURS = 4;
export const INTEL_OVERDUE_PLANNED_HOURS = 2;

export function hoursBetween(from: Date, to: Date): number {
  return (to.getTime() - from.getTime()) / (1000 * 60 * 60);
}

export function hoursAgo(iso: string | null | undefined, now: Date): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return hoursBetween(d, now);
}

export function latestIso(dates: Array<string | null | undefined>): string | null {
  let best: number | null = null;
  let bestIso: string | null = null;
  for (const iso of dates) {
    if (!iso) continue;
    const t = new Date(iso).getTime();
    if (Number.isNaN(t)) continue;
    if (best == null || t > best) {
      best = t;
      bestIso = iso;
    }
  }
  return bestIso;
}

const HEALTH_LABELS: Record<string, string> = {
  HEALTHY: 'В норме',
  DELAYED: 'Есть задержка',
  STALLED: 'Исполнение остановилось',
  BLOCKED: 'Исполнение заблокировано',
  CRITICAL: 'Критическое состояние'
};

export function healthStateLabel(state: string): string {
  return HEALTH_LABELS[state] ?? state;
}
